// ==========================================================================
// GLOBAL JAVASCRIPT - Yapılır Theme
// ==========================================================================

(function() {
  'use strict';

  // DOM Ready
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Animate on scroll
  function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('[data-animate]');
    
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      animatedElements.forEach(el => observer.observe(el));
    } else {
      animatedElements.forEach(el => el.classList.add('is-visible'));
    }
  }

  // Sticky header
  function initStickyHeader() {
    const header = document.querySelector('.header');
    if (!header) return;

    let lastScrollY = window.scrollY;
    const scrollThreshold = 100;

    const handleScroll = debounce(() => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      // Hide/show on scroll direction
      if (currentScrollY > lastScrollY && currentScrollY > 300) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }

      lastScrollY = currentScrollY;
    }, 10);

    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  // Lazy load images
  function initLazyLoad() {
    if ('loading' in HTMLImageElement.prototype) {
      // Native lazy loading supported
      const images = document.querySelectorAll('img[loading="lazy"]');
      images.forEach(img => {
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }
      });
    } else {
      // Fallback for older browsers
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js';
      document.body.appendChild(script);
    }
  }

  // Quantity input
  function initQuantityInputs() {
    document.querySelectorAll('.quantity-input').forEach(wrapper => {
      const input = wrapper.querySelector('input');
      const minusBtn = wrapper.querySelector('[data-action="minus"]');
      const plusBtn = wrapper.querySelector('[data-action="plus"]');

      if (!input) return;

      const min = parseInt(input.min) || 1;
      const max = parseInt(input.max) || 999;

      minusBtn?.addEventListener('click', () => {
        const newValue = parseInt(input.value) - 1;
        if (newValue >= min) {
          input.value = newValue;
          input.dispatchEvent(new Event('change'));
        }
      });

      plusBtn?.addEventListener('click', () => {
        const newValue = parseInt(input.value) + 1;
        if (newValue <= max) {
          input.value = newValue;
          input.dispatchEvent(new Event('change'));
        }
      });
    });
  }

  // Smooth scroll for anchor links
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;
        
        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // Format currency
  window.formatMoney = function(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    
    return parts.join(',') + ' TL';
  };

  // Initialize all
  ready(function() {
    initScrollAnimations();
    initStickyHeader();
    initLazyLoad();
    initQuantityInputs();
    initSmoothScroll();
  });
})();
